module.exports = __webpack_public_path__ + "img/qrcode_south.9433dee3.png";